import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Basic URL validation (can be improved)
export const isValidUrl = (urlString: string | null | undefined): boolean => {
  if (!urlString) return false;
  try {
    // Use new URL constructor for basic validation
    // Add protocols if missing for a more robust check if needed
    // e.g., if (!urlString.startsWith('http')) urlString = 'https://' + urlString;
    new URL(urlString);
    // Further checks could be added here (e.g., check for common image extensions)
    return true;
  } catch (_) {
    return false;
  }
};
